export const VARIANT_AIRBNB = 'airbnb'
export const VARIANT_BUNDLE = 'bundle'
export const VARIANT_CIS = 'cis'
export const VARIANT_KORU_KIDS = 'koruKids'
export const VARIANT_SELF_EMPLOYED_PLATFORM = 'selfEmployedPlatform'
export const VARIANT_SELF_EMPLOYED_SUBSCRIPTION = 'selfEmployedSubscription'
export const VARIANT_TAX_CONSULTATION = 'taxConsultation'
export const VARIANT_TAX_RETURN = 'taxReturn'
export const VARIANT_UTR = 'utr'
export const VARIANT_EIS = 'eis'
export const VARIANT_OFF_PLATFORM_SERVICES = 'offPlatformServiceRequest'
export const VARIANT_OFF_PLATFORM_SERVICES_ENABLED = 'offPlatformServiceRequestEnabled'
export const VARIANT_COMPANY_RETURN = 'companyReturn'
